import React from 'react';
import {StyleProp, TextStyle} from 'react-native';
import CCText from '@/Atoms/CCText';

// Thunder display numeral (ratings, big stat numbers, avatar initials).
// Thunder ships as a SINGLE weight (DEV_HANDOFF_SPEC §1.2) -- this wrapper
// forces the Thunder family and never passes a fontWeight, so nothing can
// faux-bold it. Callers pass size/color/lineHeight, not a fontWeight; a
// fontWeight in `style` would defeat the purpose, so don't.
type Props = {
  size: number;
  color?: string;
  lineHeight?: number;
  style?: StyleProp<TextStyle>;
  children: React.ReactNode;
};

export default function ThunderText({
  size,
  color = '#262322',
  lineHeight,
  style,
  children,
}: Props) {
  return (
    <CCText
      fontWeight="thunder"
      style={[
        {fontSize: size, color, ...(lineHeight != null ? {lineHeight} : {})},
        style,
      ]}>
      {children}
    </CCText>
  );
}
